var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgType2Slider2Left(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.14 14.9111L18.194 10.9921",
    stroke: "#D8D8D8",
    strokeWidth: 1.524,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 20.666L21.5 11.5",
    stroke: "#D8D8D8",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.194 22.53L11.14 18.61",
    stroke: "#D8D8D8",
    strokeWidth: 1.524,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.333 19.999C9.17377 19.999 10.666 18.5068 10.666 16.666C10.666 14.8252 9.17377 13.333 7.333 13.333C5.49223 13.333 4 14.8252 4 16.666C4 18.5068 5.49223 19.999 7.333 19.999Z",
    fill: "#D8D8D8",
    stroke: "#D8D8D8",
    strokeWidth: 1.524,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.667 11.999C22.5077 11.999 24 10.5068 24 8.66601C24 6.82524 22.5077 5.33301 20.667 5.33301C18.8262 5.33301 17.334 6.82524 17.334 8.66601C17.334 10.5068 18.8262 11.999 20.667 11.999Z",
    fill: "#D8D8D8",
    stroke: "#D8D8D8",
    strokeWidth: 1.524,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 26.666C23.8408 26.666 25.333 25.1738 25.333 23.333C25.333 21.4922 23.8408 20 22 20C20.1592 20 18.667 21.4922 18.667 23.333C18.667 25.1738 20.1592 26.666 22 26.666Z",
    fill: "#D8D8D8",
    stroke: "#D8D8D8",
    strokeWidth: 1.524,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgType2Slider2Left);
export default __webpack_public_path__ + "static/media/Type 2_slider 2_left.0dd4bc495fe1a3a092b5f70f93c57cce.svg";
export { ForwardRef as ReactComponent };